import { timer } from 'rxjs';
import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { UserProfileService } from '../user-profile.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-session-dialog',
    templateUrl: './session-dialog.component.html',
    providers: [BsModalService],
    standalone: false
})
export class SessionDialogComponent {
  @Input() public title: string = '';
  @Input() public message: string;
  public timeLeft: string = '3:00';
  public subscription: any;
  public isSessionOver: boolean = false;
  constructor(
    public bsModalRef: BsModalRef,
    private userProfileService: UserProfileService,
    private router?: Router
  ) {
    this.subscription = timer(1000, 1000).subscribe((tick) => {
      this.timeLeft = this.readableTime(180 - tick);
      if (tick === 180) {
        this.subscription.unsubscribe();
        this.isSessionOver = true;
      }
    });
  }
  public readableTime(t: number) {
    let seconds = t % 60 > 9 ? '' + t % 60 : '0' + t % 60;
    return Math.floor(t / 60).toString() + ':' + seconds;
  }
  public onContinue() {
    this.bsModalRef.hide();
    this.subscription.unsubscribe();
    this.userProfileService.getUserProfile().subscribe(() => {
      // ignoring the response as this is an idempotent call.
    });
  }
  public onLogOutConfirm() {
    this.bsModalRef.hide();
    this.subscription.unsubscribe();
  }
  public redirect() {
    sessionStorage.clear();
    if (this.router) {
      this.router.navigate(['/login']);
    }
  }
}